import { defineAsyncComponent } from 'vue'
export default {
  custom: defineAsyncComponent(() => import("D:/my-projects/vue-app/nuxt-app/app/layouts/custom.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("D:/my-projects/vue-app/nuxt-app/app/layouts/default.vue").then(m => m.default || m))
}